import { useEffect } from "react";

export const HotjarSetup = () => {

  useEffect(() => {
    setupHotjar();
  }, []);
};

// replaces inline script for better security by avoiding csp with `unsafe-inline`
function setupHotjar() {
  (function (h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function () {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: `${hotjarAccountId}`, hjsv: version };
    a = o.getElementsByTagName("head")[0];
    r = o.createElement("script");
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
}




const hotjarAccountId = process.env.REACT_APP_HOTJAR_ID;
const version = 6;
